import clsx from 'clsx';
import { useState } from 'react';
import { Bubble, Props as BubbleProps } from './Bubble';

type Props = BubbleProps;

export const InputInvitationCodeBubble = (props: Props) => {
  const [value, setValue] = useState('');
  const code = value.trim();
  const canSubmit = code.length > 0;

  const submit = () => {
    if (!canSubmit) return;
    props.onSend(code);
  };

  const skip = () => props.onSend('利用しない');

  return (
    <>
      <Bubble {...props}>
        <div className="rounded-2xl border bg-white px-4 py-3 drop-shadow-sm">
          <p className="whitespace-pre-line">{props.message.text}</p>
        </div>
      </Bubble>
      {props.isWaiting && <div className="h-40"></div>}
      {props.isWaiting && (
        <div className="fixed bottom-0 w-full max-w-[480px] bg-white p-3">
          <div className="mb-3">
            <label className="mb-2 block text-sm text-gray-600">招待コード</label>
            <input
              type="text"
              value={value}
              maxLength={16}
              onChange={(e) => setValue(e.target.value)}
              placeholder="例）ABCDEFGH"
              className={clsx(
                'w-full rounded-md border bg-slate-50 px-3 py-3 text-lg focus:outline-none',
                canSubmit ? 'border-[#ED70C2] focus:border-[#ED70C2]' : 'border-[#a3a3a4]',
              )}
            />
          </div>
          <div className="flex gap-2">
            <button
              onClick={skip}
              className="flex-1 rounded-md border border-[#ff66c4] bg-white py-3 font-bold text-[#ff66c4]"
            >
              利用しない
            </button>
            <button
              disabled={!canSubmit}
              onClick={submit}
              className={clsx(
                'flex-1 rounded-md border py-3 font-bold text-white',
                canSubmit ? 'border-[#ff66c4] bg-[#ff66c4]' : 'border-[#a3a3a4] bg-[#f2f2f3]',
              )}
            >
              確定
            </button>
          </div>
        </div>
      )}
    </>
  );
};
